import { render, staticRenderFns } from "./DownloadAppBanner.vue?vue&type=template&id=64e41650&scoped=true"
import script from "./DownloadAppBanner.vue?vue&type=script&lang=js"
export * from "./DownloadAppBanner.vue?vue&type=script&lang=js"
import style0 from "./DownloadAppBanner.vue?vue&type=style&index=0&id=64e41650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e41650",
  null
  
)

export default component.exports